import { XCircleIcon } from "lucide-react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { OpeningTimesDay, StoreFormValues } from "./types";
import useTranslation from "@babackapp/translations/use-translation";

type OpeningTimesRangesProps = {
  day: OpeningTimesDay;
};

export default function OpeningTimesRanges({ day }: OpeningTimesRangesProps) {
  const t = useTranslation();
  const { control } = useFormContext<StoreFormValues>();

  const ranges = useFieldArray({
    control,
    name: `openingTimes.${day}`,
  });

  return (
    <span className="flex items-center flex-wrap gap-2">
      {ranges.fields.length === 0 && (
        <span className="text-xs block text-muted-foreground">
          {t("settings.shop.physic.fields.closedAllDay")}
        </span>
      )}
      {ranges.fields.map((range, index) => (
        <span
          key={index}
          className="group relative bg-muted text-xs text-muted-foreground rounded-full px-2 py-1 cursor-pointer overflow-hidden"
        >
          <span className="z-0 group-hover:opacity-0">
            {range.from} - {range.to}
          </span>
          <a
            href="#"
            role="button"
            onClick={() => ranges.remove(index)}
            className="flex items-center justify-center bg-black/50 z-10 absolute inset-0 opacity-0 group-hover:opacity-100"
          >
            <XCircleIcon className="size-4 text-white" />
          </a>
        </span>
      ))}
    </span>
  );
}
